import { useState } from 'react';
import { useAnimationFrame } from 'motion/react';

import {
  OBS_MESSAGE,
  SOCIAL,
  PLEASE_WAIT,
  FONT_COLOR,
  FONT_SIZE,
  BG_COLOR,
  WEEKDAY_FORMAT,
  DAY_FORMAT,
  MONTH_FORMAT,
  YEAR_FORMAT,
  FONT_FAMILY,
  LOWERCASE,
} from '../config';

const visible = true;

function Boom(props) {
  const {
    children = null,
    fontSize = 1,
    fontColor = '#ffffff',
    bgColor = '#000000',
    style = {}
  } = props || {};

  return (
    <div style={{
      position: 'absolute',
      bottom: '0.5rem',
      right: '0.5rem',
      ...style
    }}>
      <div style={{
        position: 'relative',
        zIndex: 2,
        fontSize: `${fontSize}rem`,
        color: fontColor,
        transform: `translate(0.25rem, 0.25rem) rotate(-1deg)`,
      }}>
        {children}
      </div>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        width: '100%',
        height: '100%',
        backgroundColor: bgColor,
        padding: '0.1rem'
      }}>
      </div>
    </div>
  );
}

export default function DateTime() {
  const date = new Date();
  const datestring = date.toLocaleDateString('en-US', {
    weekday: WEEKDAY_FORMAT,
    year: YEAR_FORMAT,
    month: MONTH_FORMAT,
    day: DAY_FORMAT,
  });
  const timestring = date.toLocaleTimeString('en-US');

  const [alpha, setAlpha] = useState(0);

  useAnimationFrame(({ t }) => {
    setAlpha(Math.sin(t * 0.001) * 0.1);
  });

  return (
    <div
      className=""
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent',
        fontFamily: FONT_FAMILY
      }}
    >
      {visible ? (
        <Boom
          fontSize={FONT_SIZE * 0.8}
          fontColor={FONT_COLOR}
          bgColor={BG_COLOR}
          style={{
            bottom: '3.25rem',
            right: '1rem',
            transform: 'rotate(2deg)',
            textTransform: LOWERCASE ? 'lowercase' : 'none',
          }}
        >
          {timestring}
        </Boom>
      ) : null}

      <Boom
        fontSize={FONT_SIZE}
        fontColor={FONT_COLOR}
        bgColor={BG_COLOR}
        style={{
          textTransform: LOWERCASE ? 'lowercase' : 'none'
        }}
      >
        {datestring}
      </Boom>


      {PLEASE_WAIT ? (
        <Boom
          fontSize={FONT_SIZE * 3}
          fontColor={FONT_COLOR}
          bgColor={BG_COLOR}
          style={{
            top: '50%',
            left: '50%',
            transform: `translate(-50%, -50%)`,
            textAlign: 'center',
          }}
        >
          I&apos;LL BE RIGHT BACK
        </Boom>
      ) : null}


      <Boom
        fontSize={FONT_SIZE * 0.7}
        fontColor={FONT_COLOR}
        bgColor={BG_COLOR}
        style={{
          bottom: '3rem',
          left: 0,
          right: 'auto',
          letterSpacing: `${alpha}rem`,
        }}
      >
        {OBS_MESSAGE}
      </Boom>
      <Boom
        fontSize={FONT_SIZE * 0.7}
        fontColor={FONT_COLOR}
        bgColor={BG_COLOR}
        style={{
          left: 0,
          right: 'auto',
          textTransform: LOWERCASE ? 'lowercase' : 'none',
        }}
      >
        {SOCIAL}
      </Boom>

      {/* Camera HUD overlay */}
      <CameraHUD
        position="top-left"
        size="medium"
        autoStart={false}
        mirror={true}
        showControls={true}
      />
    </div>
  );
};
